export default __webpack_public_path__ + "d00d6ff98d6efa3c8cc36ecc62032bb3.png";